import { GAME_CONFIG, TYPES, WIN_MATRIX } from './constants';

/**
 * 創建初始代理人列表
 */
export const createAgents = (width, height, radius) => {
  const agents = [];
  const initPerType = Math.floor(GAME_CONFIG.AGENTS_COUNT / 3);
  let types = [];
  
  for (let t = 0; t < 3; t++) {
    for (let i = 0; i < initPerType; i++) types.push(t);
  }

  while (types.length < GAME_CONFIG.AGENTS_COUNT) {
    types.push(Math.floor(Math.random() * 3));
  }

  shuffleArray(types);

  for (let i = 0; i < GAME_CONFIG.AGENTS_COUNT; i++) {
    agents.push({
      id: i,
      type: types[i],
      x: Math.random() * (width - 2 * radius) + radius,
      y: Math.random() * (height - 2 * radius) + radius,
      dx: (Math.random() - 0.5) * GAME_CONFIG.SPEED * 2,
      dy: (Math.random() - 0.5) * GAME_CONFIG.SPEED * 2,
      bump: 0,
      glow: 0,
    });
  }
  return agents;
};

/**
 * 遊戲物理步進計算
 * 核心：確保碰撞後的數據立即反映在 counts 中
 */
export const updatePhysics = (agents, width, height, radius) => {
  let winnerType = null;
  const counts = [0, 0, 0];

  // 1. 移動處理
  for (const agent of agents) {
    agent.x += agent.dx;
    agent.y += agent.dy;

    if (agent.x < radius || agent.x > width - radius) agent.dx *= -1;
    if (agent.y < radius || agent.y > height - radius) agent.dy *= -1;

    agent.x = Math.max(radius, Math.min(agent.x, width - radius));
    agent.y = Math.max(radius, Math.min(agent.y, height - radius));

    if (agent.bump > 0) agent.bump--;
    if (agent.glow > 0) agent.glow--;
  }

  // 2. 碰撞檢測與同化
  const distThreshold = radius * GAME_CONFIG.COLLISION_DIST_RATIO;
  for (let i = 0; i < agents.length; i++) {
    for (let j = i + 1; j < agents.length; j++) {
      const a = agents[i];
      const b = agents[j];
      if (a.type === b.type) continue;

      const dx = a.x - b.x;
      const dy = a.y - b.y;
      const distSq = dx * dx + dy * dy;

      if (distSq < distThreshold * distThreshold) {
        if (WIN_MATRIX[a.type][b.type]) {
          b.type = a.type;
          a.bump = 12; // 視覺反饋稍微增強
          a.glow = 15;
        } else if (WIN_MATRIX[b.type][a.type]) {
          a.type = b.type;
          b.bump = 12;
          b.glow = 15;
        }
      }
    }
  }

  // 3. 碰撞後立即精確統計
  for (const agent of agents) {
    counts[agent.type]++;
  }

  // 4. 判定勝負
  const aliveTypes = counts.filter(c => c > 0).length;
  if (aliveTypes === 1) {
    winnerType = counts.findIndex(c => c > 0);
  }

  return { winnerType, counts };
};

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}